"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDomainPharmacy = exports.useGetPharmacyAppointmentOptions = exports.useSearchPharmacy = exports.usePharmacy = void 0;
var pharmacy_1 = require("../pharmacy");
var react_query_1 = require("react-query");
function usePharmacy(pharmId, options) {
    return (0, react_query_1.useQuery)(["pharmacy", pharmId], function () { return (0, pharmacy_1.getPharmacy)(pharmId); }, options);
}
exports.usePharmacy = usePharmacy;
function useSearchPharmacy(request, options) {
    return (0, react_query_1.useQuery)(["searchPharmacy", request.searchText], function () { return (0, pharmacy_1.searchPharmacy)(request); }, options);
}
exports.useSearchPharmacy = useSearchPharmacy;
function useGetPharmacyAppointmentOptions() {
    return (0, react_query_1.useQuery)(["getPharmacyAppointmentOptions"], pharmacy_1.getPharmacyAppointmentOptions);
}
exports.useGetPharmacyAppointmentOptions = useGetPharmacyAppointmentOptions;
function useDomainPharmacy(domain, options) {
    return (0, react_query_1.useQuery)(["getDomainPharmacy", domain], function () { return (0, pharmacy_1.getDomainPharmacy)(domain); }, options);
}
exports.useDomainPharmacy = useDomainPharmacy;
